import React, { useContext, useEffect, useState } from 'react'

import { Pagination, Input, Tag, Typography } from 'antd';

import { CreateAudienceDataContext } from '../../../helpers/Context';
import { apiGetUsersList } from '../../../helpers/Api';
import TableAudience from '../../tables/TableAudience'
import { addKeys } from '../../../helpers/AddKey';
import TableSkeleton from '../../TableSkeleton';

const { Search } = Input;


export default function MarketingAudienceShowContent({ contextValue, audienceIdArray, hideSelection, audienceTitlesArray }) {

  const [searchString, setSearchString] = useState("")
  
  const [loading, setLoading] = useState(true)

  const [totalPages, setTotalPages] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [users, setUsers] = useState(null);
  const [page, setPage] = useState(1);
  
  const {
    errorNotification,
    publicCode
  } = contextValue;

  const audienceDataContext = useContext(CreateAudienceDataContext);
  
  /////////////////////////////////////////////////////////////////////////////////////////// 
  //////////////////// recupero dati utente ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

    const fetchUsers = (searchString) => {
      if (!publicCode) return;

          setLoading(true);

          const body = {
            public_code: publicCode,
            audienceCampaignIds: audienceIdArray,
            page: page
          };

          (async () => {
            try {
              const res = await apiGetUsersList(body, searchString);

              if (!res.message) {
                setTotalPages(res.totalPages)
                setUsers(addKeys(res?.users, "idCustomer"));
                setTotalUsers(res?.totalUsers)
                setLoading(false);
              } else {
                errorNotification(res.message);
                setLoading(false);
              }
            } catch (error) {
              errorNotification('Errore durante il recupero utenti');
              console.error('Errore durante il recupero utenti:', error);
              setLoading(false);
            }
          })();

    }
  
    useEffect(() => {
      fetchUsers(searchString);
    }, [audienceIdArray, publicCode, page]);


   /////////////////////////////////////////////////////////////////////////////////////////// 
           //////////////////// recupero dati utente ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  ///////////////////////////////////////////////////////////////////////////////////////////
           //////////////////// ricerca e paginazione ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  
  
  const AudiencePagination = () => (
    <Pagination
      onChange={(page,pageSize)=>setPage(page)}
      showTotal={(total, range) => `${range[0]}-${range[1]} di ${total} utenti`}
      showSizeChanger={false}
      defaultCurrent={1}
      total={totalUsers}
      showQuickJumper
      current={page}
      pageSize={20}
      responsive
    />
  );

  //////////////////////////////////////////////////////////////////////////////////////////
           //////////////////// ricerca e paginazione ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchString(value);
  };


  const onSearch = (value) => {
    fetchUsers(searchString);
  };

  return (
    <div className='p-10 mb-20'>
  
      {/*  ---------- area con i pubblici interrogati ----------*/}
      {audienceTitlesArray?.length > 0 &&
        <div className='di-card mb-20 mt-20 gap-10 flex flex-wrap'>
          <div><Typography>Stai osservando gli utenti dei pubblici:</Typography></div>
          <div className='flex flex-wrap gap-10'>
            {audienceTitlesArray.map((audienceTitle) => <Tag>{audienceTitle}</Tag>)}
          </div>
        </div>
      }
      {/*  ---------- area con i pubblici interrogati ----------*/}
  
      {/*  ---------- area superiore con ricerca e paginazione ----------*/}
      <div className='di-card mb-20 mt-20'>
          <div className='flex flex-wrap gap-10 space-between'>
            <div className="max-w-250">
              <Search
                onChange={handleSearchText}
                placeholder="Mario Rossi"
                value={searchString}
                onSearch={onSearch}
                size="medium"
              />
            </div>
            <AudiencePagination />
          </div>
      </div>
      {/*  ---------- area superiore con ricerca e paginazione ----------*/}

  
      {/* ---------- sezione tabella con dati  ---------- */}
      {loading ?
        <div className='di-card'>
          <TableSkeleton />
        </div>
      :
        <div className='di-card'>
          
          <TableAudience
            hideRowSelection={hideSelection}
            contextValue={contextValue}
            loading={loading}
            data={users}
          />
        </div>
      }
      {/* ---------- sezione tabella con dati  ---------- */}


      {/*  ---------- area inferiore paginazione ----------*/}
     <div className='di-card mt-20 mb-20'>
        <div className='flex flex-wrap w-100 justify-end'>
          <AudiencePagination />
        </div>
     </div>
      {/*  ---------- area inferiore paginazione ----------*/}

      
    </div>
  )
}
